import React from 'react'
import classes from '../AddJob.module.css'
import { Col } from 'react-bootstrap'


interface FieldProps{
    width?: number,
    height?: number,
    placeholder?: string,
    title: string,
    value?: string,
    inputType?: string,
    tip?: string,
    onChangeValue: (v: string)=>void,
    text?: boolean,
    disabled?: boolean
  }
  
  
export  const FieldComponent: React.FC<FieldProps> = (props)=>{
  
  
    return(
        <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          {props.tip && <p className={classes.tip}>({props.tip})</p>}
          <p className={classes.fieldTitle}>{props.title}</p>
          </div>
          {props?.text ? <textarea 
            style={{
              width: props?.width, 
              height: props?.height, 
              backgroundColor: props.disabled ? 'rgb(45, 45, 45)' : 'transparent'}}
            disabled={props.disabled}
            value={props.value} 
            onChange={({target})=>props.onChangeValue(target.value)} 
            placeholder={props?.placeholder} 
            className={[classes.myInput,classes.textInput].join(' ')} 
            /> : 
          <input 
              className={props.text ? [classes.myInput,classes.textInput].join(' ') : classes.myInput}
              style={{
                width: props?.width, 
                height: props?.height, 
                backgroundColor: props.disabled ? 'rgb(45, 45, 45)' : 'transparent'}}
              type={props?.inputType}
              placeholder={props.disabled ? 'xxxxxxxxx' : props?.placeholder}
              disabled={props.disabled}
              value={props.value}
              onChange={({target})=>props.onChangeValue(target.value)}
              min={0}
          />}
        </Col>
    )
  }
  